module.exports = __webpack_public_path__ + "img/KG.015a0766.png";